import React, { Component } from 'react'
import { Field } from "redux-form";
import TextInput from '../../../system/fields/TextInput';
import { Button, FormGroup, Label } from 'reactstrap';
import FileUpload from '../../../system/fields/FileUpload';
import Wysiwyg from '../../../system/fields/Wysiwyg';
import HTTP from '../../../system/utils/Http'
import SelectDropdown from '../../../system/fields/SelectDropdown';
import * as validations from "../../../system/utils/Validation"

class Activities extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: []
        }

    }
    componentDidMount() {
        HTTP.get('/activity-categories/')
            .then(res => {
                this.setState({
                    categories: res.data.data
                })
            })
    }
    render() {
        const { fields } = this.props

        return (
            <div className={"repeater-container"}>
                {fields.map((section, i) => (
                    <React.Fragment>
                        <div className="row top-field">
                            <FormGroup className="col-12">
                                <Label>Activity Title</Label>
                                <Field
                                    name={`${section}.name`}
                                    component={TextInput}
                                    type="text"
                                />
                            </FormGroup>
                            <FormGroup className="col-12">
                                <Label>Activity Category</Label>
                                <Field
                                    name={`${section}.category`}
                                    component={SelectDropdown}
                                    options={this.state.categories}
                                    labelKey={"name"}
                                    valueKey={"id"}
                                    type="text"
                                    multi={false}
                                    className="form-control"

                                />
                            </FormGroup>
                            <FormGroup className="col-12">
                                <Label>Activity subheading</Label>
                                <p style={{ fontStyle: 'italic' }}>Must be 50 characters or less</p>
                                <Field
                                    name={`${section}.heading`}
                                    component={TextInput}
                                    type="text"
                                    validate={validations.maxLength(50)}

                                />
                            </FormGroup>
                            <FormGroup className="col-12">
                                <Label>Image</Label>
                                <Field
                                    name={`${section}.image`}
                                    component={FileUpload}
                                />
                            </FormGroup>
                            <FormGroup className="col-12">
                                <Label>Paragraph</Label>
                                <Field
                                    name={`${section}.description`}
                                    component={Wysiwyg}
                                    type={"text"}
                                />
                            </FormGroup>

                        </div>
                        <button className="btn btn-outline-danger" style={{ marginBottom: '30px' }} onClick={() => fields.remove(i)}>
                            Remove
                            </button>
                    </React.Fragment>
                ))}
                <div className={"add-button bottom"}>
                    <Button
                        type={"button"}
                        onClick={() => fields.push({ section_type: "" })}
                    >
                        Add Section
          </Button>
                </div>
            </div>
        );
    }
};

export default Activities;


// WEBPACK FOOTER //
// ./src/containers/SubCategories/components/Activites.jsx